<template>
  <el-card class="main-card-box">
    <el-alert
      :closable="false"
      description="系统错误"
      show-icon
      title="500"
      type="error">
    </el-alert>
  </el-card>
</template>
<script>
  export default {
    name: 'error-500'
  };
</script>
